/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Fix_ErrorsInputs */

const en_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the highlighted fields.`)
};

const de_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie die markierten Felder.`)
};

const fr_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez les champs signalés.`)
};

const es_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa los campos marcados.`)
};

const it_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla i campi evidenziati.`)
};

const nl_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer de gemarkeerde velden.`)
};

const pl_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź zaznaczone pola.`)
};

const fi_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista merkityt kentät.`)
};

const da_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollér de markerede felter.`)
};

const sv_consumer_declaration_fix_errors = /** @type {(inputs: Consumer_Declaration_Fix_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollera de markerade fälten.`)
};

/**
* | output |
* | --- |
* | "Check the highlighted fields." |
*
* @param {Consumer_Declaration_Fix_ErrorsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_fix_errors = /** @type {((inputs?: Consumer_Declaration_Fix_ErrorsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Fix_ErrorsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_fix_errors(inputs)
	if (locale === "fr") return fr_consumer_declaration_fix_errors(inputs)
	if (locale === "es") return es_consumer_declaration_fix_errors(inputs)
	if (locale === "it") return it_consumer_declaration_fix_errors(inputs)
	if (locale === "nl") return nl_consumer_declaration_fix_errors(inputs)
	if (locale === "pl") return pl_consumer_declaration_fix_errors(inputs)
	if (locale === "fi") return fi_consumer_declaration_fix_errors(inputs)
	if (locale === "da") return da_consumer_declaration_fix_errors(inputs)
	if (locale === "sv") return sv_consumer_declaration_fix_errors(inputs)
	return en_consumer_declaration_fix_errors(inputs)
});